import { call, select, takeLatest } from 'redux-saga/effects'

import { saveUserMeta } from 'helpers/utils'
import { selectRecentTopics } from 'containers/RecentTopics/selectors'
import { ADD_RECENT } from './constants'

function* addRecentWorker(action) {
  const state = yield select()
  const topics = selectRecentTopics(state)
  yield call(saveUserMeta, 'recent_topics', topics)
}

export default function* watcher() {
  yield takeLatest(ADD_RECENT, addRecentWorker)
}
